<h2 mat-dialog-title>{{ "reason-for-disposing.title" | translate }}</h2>
<mat-dialog-content>
  <div>
    <!-- <form class="form-width">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ response }}</mat-label>
        <textarea matInput rows="6" cols="100" disabled></textarea>
      </mat-form-field>
    </form> -->
    {{ response }}
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="mat-card-action">
  <button mat-raised-button mat-dialog-close>Close</button>
</div>
